import React from "react";
import { useTranslation } from "react-i18next";
import SectionBadge from "../../../components/shared/Title";
import FeatureCard from "./FeatureCard";
import { RiSparkling2Line } from "react-icons/ri";

import MotionDiv from "@/components/animations/MotionDiv";
import { fadeUp, stagger } from "@/animations/variants";

import { useFeatures } from "@/hooks/useFeatures";

const FeaturesSection = () => {
  const { t, i18n } = useTranslation();
  const isAR = i18n.language?.toLowerCase().startsWith("ar");

  const { features, loading, error } = useFeatures(isAR);

  return (
    <section id="features" className="py-10">
      <div className="container mx-auto px-4 md:px-8">

        {/* Badge */}
        <MotionDiv variants={fadeUp}>
          <SectionBadge
            text={t("featuresSection.badge")}
            icon={<RiSparkling2Line />}
          />
        </MotionDiv>

        {/* Title */}
        <MotionDiv variants={fadeUp}>
          <h2 className="text-primary mt-6 text-center text-5xl font-medium">
            {t("featuresSection.title")}
          </h2>
        </MotionDiv>

        {/* Subtitle */}
        <MotionDiv variants={fadeUp}>
          <p className="mx-auto mt-4 max-w-2xl text-center font-medium text-gray-500 md:text-3xl">
            {t("featuresSection.subtitle")}
          </p>
        </MotionDiv>

        {/* Grid */}
        <MotionDiv
          variants={stagger}
          className="mt-16 grid gap-12 sm:grid-cols-2 lg:grid-cols-3"
        >
          {loading && <p>{isAR ? "جاري تحميل المميزات..." : "Loading features..."}</p>}
          {error && <p className="text-red-500">{error}</p>}

          {!loading && !error && features.map((item) => (
            <MotionDiv key={item.id} variants={fadeUp}>
              <FeatureCard
                icon={item.icon}
                title={item.title}
                description={item.desc}
              />
            </MotionDiv>
          ))}
        </MotionDiv>

      </div>
    </section>
  );
};

export default FeaturesSection;